module.exports = __webpack_public_path__ + "img/bg-mid-414.e7e28be6.png";